import { useMemo } from "react";
import AxisLabels from "./AxisLabels";
import SpectrumSide from "./SpectrumSide";
import { leftLabelWidth } from "./chartConfig";
import useGetSpectrum from "./hooks/useGetSpectrum";
import LateralityInput from "./LateralityInput";
import { containerWidth } from "./chartConfig";

const SpectrumPreview = ({ id, data, viewOnly, size }) => {
  const { data: spectrumDataFromApi } = useGetSpectrum({ id });
  const spectrumData = data != null ? data : spectrumDataFromApi;

  const lateralitySorted = useMemo(() => {
    if (!Array.isArray(spectrumData?.laterality)) return [];
    return [...spectrumData.laterality].sort((a, b) => a.f - b.f);
  }, [spectrumData?.laterality]);

  const {
    selectivityOK,
    selectivityNT,
    selectivityLeftOK,
    selectivityRightOK,
  } = useMemo(() => {
    const left = spectrumData?.left?.blue_slashes;
    const right = spectrumData?.right?.blue_slashes;
    const leftOK = Array.isArray(left) && left.length === 0;
    const rightOK = Array.isArray(right) && right.length === 0;
    return {
      selectivityLeftOK: leftOK,
      selectivityRightOK: rightOK,
      selectivityOK: leftOK && rightOK,
      selectivityNT: spectrumData != null && (left == null || right == null),
    };
  }, [spectrumData]);

  return (
    <div>
      <div style={{ display: "flex", flexShrink: "0" }}>
        <div style={{ position: "relative" }}>
          {size !== "small" && !selectivityOK && selectivityRightOK ? (
            <h3
              style={{
                textAlign: "center",
                marginTop: "10px",
                color: "var(--clr-blue-500)",
                position: "absolute",
                left: "0",
                right: "0",
              }}
            >
              OK
            </h3>
          ) : null}
          <SpectrumSide
            key={"RIGHT"}
            labelsOnTop
            labelsOnLeft
            data={spectrumData?.right}
            viewOnly={viewOnly}
            side={"right"}
            size={size}
          />
        </div>
        {size !== "small" && (
          <div
            style={{
              position: "relative",
              width: `${leftLabelWidth}px`,
              flexShrink: 0,
            }}
          >
            {selectivityOK || selectivityNT ? (
              <h3
                style={{
                  textAlign: "center",
                  marginTop: "10px",
                  color: "var(--clr-blue-500)",
                }}
              >
                {selectivityOK ? "OK" : selectivityNT ? "NT" : ""}
              </h3>
            ) : null}
            <AxisLabels
              onLeft
              labelsOnTop
              labelsOnLeft
              oddOnly
              noPadding
              size={size}
            />
          </div>
        )}
        <div style={{ position: "relative" }}>
          {size !== "small" && !selectivityOK && selectivityLeftOK ? (
            <h3
              style={{
                textAlign: "center",
                marginTop: "10px",
                color: "var(--clr-blue-500)",
                position: "absolute",
                left: "0",
                right: "0",
              }}
            >
              OK
            </h3>
          ) : null}
          <SpectrumSide
            key={"LEFT"}
            data={spectrumData?.left}
            labelsOnTop
            labelsOnRight
            viewOnly={viewOnly}
            side={"left"}
            size={size}
          />
        </div>
      </div>
      {lateralitySorted.length > 0 && size !== "small" ? (
        <div
          style={{
            display: "flex",
            width: `${containerWidth * 2 + 40}px`,
            gap: "var(--gap-base)",
            paddingTop:
              size !== "small" ? "var(--padding-section-header)" : "unset",
            paddingBottom:
              size !== "small" ? "var(--padding-section-bottom)" : "unset",
            justifyContent: "center",
          }}
        >
          {lateralitySorted.map((laterality) => (
            <LateralityInput
              key={laterality.f}
              caption={laterality.f}
              value={laterality.v}
              viewOnly
              size={size}
            />
          ))}
        </div>
      ) : null}
    </div>
  );
};

export default SpectrumPreview;
